/**
 * Representation of com.rygen.corsair.domain.shipment.enums.ManifestStatus
 */
export enum ManifestStatus {
  MANIFESTED = 'MANIFESTED',
  CANCELED = 'CANCELED',
  FAILED = 'FAILED',
}
